


















import { Vue, Prop, Component } from 'vue-property-decorator'

@Component
export default class NavButton extends Vue {
  @Prop() routeLink!: object

  // noinspection JSUnusedLocalSymbols
  private route () {
    this.$router.push(this.routeLink)
  }
}
